module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-57x57-b3268d79a28963bba5320c70f8ac3a52.png";